import api, { TOKEN_STORAGE_KEY } from "./client";

const buildStreamUrl = () => {
  const baseUrl = api.defaults?.baseURL || "/api";
  const normalized = baseUrl.startsWith("http")
    ? baseUrl
    : baseUrl.startsWith("/")
      ? baseUrl
      : `/${baseUrl}`;

  return `${normalized.replace(/\/?$/, "")}/status/stream`;
};

export const subscribeToActiveUnitStream = ({ onMessage, onError, onOpen } = {}) => {
  if (typeof EventSource === "undefined") {
    return null;
  }

  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const url = new URL(buildStreamUrl(), window.location.origin);

  if (token) {
    url.searchParams.set("access_token", token);
  }

  const eventSource = new EventSource(url.toString(), { withCredentials: false });

  if (typeof onOpen === "function") {
    eventSource.addEventListener("open", onOpen);
  }

  eventSource.addEventListener("message", (event) => {
    if (typeof onMessage !== "function") {
      return;
    }

    try {
      const payload = JSON.parse(event.data);
      onMessage(payload);
    } catch (error) {
      console.warn("Unable to parse active unit stream payload", error);
    }
  });

  eventSource.addEventListener("error", (event) => {
    if (typeof onError === "function") {
      onError(event);
    }
  });

  return eventSource;
};
